/*
 * Desain Figma menggabungkan berita dan artikel dalam satu halaman; /artikel
 * tetap ada agar tautan lama tidak putus dan menampilkan halaman yang sama.
 */
export { default } from './berita';
